import { render, staticRenderFns } from "./PartsList.vue?vue&type=template&id=4f7a11e0&"
import script from "./PartsList.vue?vue&type=script&lang=js&"
export * from "./PartsList.vue?vue&type=script&lang=js&"
import style0 from "./PartsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7a11e0')) {
      api.createRecord('4f7a11e0', component.options)
    } else {
      api.reload('4f7a11e0', component.options)
    }
    module.hot.accept("./PartsList.vue?vue&type=template&id=4f7a11e0&", function () {
      api.rerender('4f7a11e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Requests/PartsList.vue"
export default component.exports